import {
  GetExamEventByIdDocument,
  useDownloadExamByExamEventIdMutation,
} from '@exam-center/graphql';
import { ConfirmationModal, Text } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

interface DownloadExamConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  examEventId: string;
}

export default function DownloadExamConfirmationModal(
  props: Readonly<DownloadExamConfirmationModalProps>,
) {
  const { open, onClose, examEventId } = props;
  const { showSnackbar } = useSnackbar();

  const [downloadExam, { loading }] = useDownloadExamByExamEventIdMutation();

  const handleSubmit = async () => {
    await downloadExam({
      variables: {
        downloadExamByExamEventIdInput: {
          examEventId,
        },
      },
      onCompleted: () => {
        showSnackbar({
          message: 'ดาวน์โหลดชุดข้อสอบเรียบร้อยแล้ว',
          variant: 'success',
        });
        onClose();
      },
      onError: () => {
        showSnackbar({
          message: 'เกิดข้อผิดพลาดในการดาวน์โหลดชุดข้อสอบ',
          variant: 'error',
        });
        onClose();
      },
      awaitRefetchQueries: true,
      refetchQueries: [GetExamEventByIdDocument],
    });
  };

  return (
    <ConfirmationModal
      title='ยืนยันการดาวน์โหลดชุดข้อสอบ?'
      content={
        <Text>
          เมื่อดำเนินการเสร็จสิ้น
          <br />
          ระบบจะจัดส่งไฟล์ชุดข้อสอบไปยังอีเมลของคุณโดยอัตโนมัติ
        </Text>
      }
      acceptText='ดาวน์โหลดชุดข้อสอบ'
      discardText='ยกเลิก'
      open={open}
      onAccept={handleSubmit}
      onClose={onClose}
      onDiscard={onClose}
      loading={loading}
    />
  );
}
